
  <div class="dialog-amount">
    <ul class="sections" *ngIf="filters.length > 1">
      <flame-chip 
        [selected]="active === i" 
        (click)="tagging(i, item)" 
        *ngFor="let item of filters; index as i"
      >{{item.replace('_', ' ') | titlecase }}</flame-chip>
    </ul>
    <ul>
      <li class="card -list" *ngFor="let item of getList()">
        <div class="card__detail" (click)="getamount(item)">
          <div class="card__data--select">
            <p class="card__select">
              ${{ item.monto | currency: 'USD':'':'1.0-0' }}
            </p>
            <p class="card__text" *ngIf="getDescription(item) as detail">
              {{ detail.description }}
              <span *ngIf="detail.socialMedia">
                <img 
                  class="img__social" 
                  [src]="item.imageLogo" 
                  [alt]="item.name" 
                  *ngFor="let item of detail.socialMedia"
                >
              </span>
            </p>
          </div>
          <div class="card__arrow">
            <flame-icon size="xs" fontIcon="chevron-right"></flame-icon>
          </div>
        </div>
      </li>
    </ul>
  </div>
  
